import { render } from "./ArtistForm.vue?vue&type=template&id=784d5f10"
import script from "./ArtistForm.vue?vue&type=script&lang=js"
export * from "./ArtistForm.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./ArtistForm.vue?vue&type=style&index=0&id=784d5f10&module=true&lang=css"
cssModules["$style"] = style0

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__